import request from '@/utils/request'

// 区域列表
export function districtList(data) {
  return request({
    url: '/sys/district/list',
    method: 'post',
    data
  })
}
// 店铺列表
export function storeListData(data) {
  return request({
    url: '/sys/store/list',
    method: 'post',
    data
  })
}
// 团队列表
export function teamListData(data) {
  return request({
    url: '/sys/team/list',
    method: 'post',
    data
  })
}
// 工种列表
export function professionListData(data) {
  return request({
    url: '/sys/profession/list',
    method: 'post',
    data
  })
}
// 员工列表
export function userListData(data) {
  return request({
    url: '/sys/user/list',
    method: 'post',
    data
  })
}
export function chongUserList(data) {
  return request({
    url: '/sys/user/list',
    method: 'post',
    data
  })
}
// 岗位列表
export function roleListData(data) {
  return request({
    url: '/sys/role/list',
    method: 'post',
    data
  })
}
// 权限列表
export function menuListData() {
  return request({
    url: '/sys/menu/list',
    method: 'get'
  })
}
